<template>
  <!-- 二维码获取openId -->
  <div class="codeToOpenid">
    <div class="pic_k">
      <img v-if="src" :src="src" alt />
      <div @click="init" v-if="outTime" class="mask">
        <div>二维码已过期</div>
        <div class="blue">点击刷新</div>
      </div>
    </div>
    <div class="tip">微信扫码注册/登录</div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      random: "", //随机码
      src: "",
      jsq: null, //计时器
      outTime: true, //越时
    };
  },
  methods: {
    init() {
      this.random = Math.floor(Math.random() * 100000);
      this.getData();
    },

    getOpenid() {
      clearInterval(this.jsq);
      this.jsq = setInterval(() => {
        this.getWXOpenId();
      }, 3000);
      setTimeout(() => {
        clearInterval(this.jsq);
        this.outTime = true;
      }, 60000);
    },

    getWXOpenId() {
      let obj = {
        tempRandom: this.random, // 微信消息提醒生成二维码随机数
      };
      this.api("getMiniInformation", obj).then((res) => {
        if (res.result) {
          clearInterval(this.jsq);
          this.$emit("bindSuccess", res.result);
        }
      });
    },

    getData() {
      let obj = {
        tempRandom: this.random,  // 随机数
        envVersion: this.u_config.envVersion, // "trial", // 版本 正式版为 release，体验版为 trial，开发版为 develop
      };
      this.outTime = false;
      this.api("getUnlimitedQRCode", obj).then((res) => {
        console.log(res);
        this.src = res.result.base64;
        this.getOpenid();
      });
    },
  },
  mounted() {
    this.init();
  },
  destroyed () {
    clearInterval(this.jsq);
  },
  
};
</script>

<style lang="scss" scoped>
.codeToOpenid {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  .pic_k {
    margin-bottom: 20px;
    width: 180px;
    height: 180px;
    position: relative;

    img {
      width: 100%;
      height: 100%;
    }

    .mask {
      cursor: pointer;
      line-height: 30px;
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      color: #000;
      background: rgba(255, 255, 255, 0.9);

      .blue {
        color: #576b95;
      }
    }
  }
}
</style>
